import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { 
            Grid, 
            Button, 
            MenuItem, 
            Select, 
            FormControl, 
            InputLabel, 
            TextField,
            InputAdornment,
            IconButton
        } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
    },
    margin: {
        margin: theme.spacing(1),
    },
    buttonBack: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
    questionSelected : {
        color : '#2E2757',
        //fontFamily: 'MyriadPro-Bold',
    },
    questionNotSelected : {
        color : 'black'
    }
}));

const FormQuestions = props => {

    const classes = useStyles();

    const { 
            handleNext, 
            handleBack, 
            question, 
            answer, 
            dataquestions, 
            handleChangeQuestion,
            handleChangeAnswer, 
            activeStep,
            formErrors,
            type,
            setType,
            sizeSteps,
            index
        } = props;
    
    const isValid = answer.length > 0 && !formErrors.answer && question > 0

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleChangeTypeText = () => {
        (type === 'text') ? setType('password') : setType('text')
    }

    return (
        
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <FormControl variant="outlined" style = {{width: '100%',}}>
                        <InputLabel id="demo-simple-select-outlined-label">Seleccione una pregunta</InputLabel>
                        <Select
                        label="Seleccione una pregunta"
                        labelId="demo-simple-select-label"
                        id={"question"+index}
                        fullWidth
                        value = { question}
                        onChange={(e) => handleChangeQuestion(e.target.value) }
                        >
                            <MenuItem key={0} value={0}>Seleccione</MenuItem>
                            {
                                (dataquestions.length > 0) && 
                                    dataquestions.map(option => {
                                        return <MenuItem key={option.id} value={option.id} className = {(option.state === 0) ? classes.questionSelected : classes.questionNotSelected}>{`${option.question}`}</MenuItem>
                                })
                                
                                //})
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                <TextField
                    fullWidth
                    label="Respuesta"
                    name="answer"
                    placeholder="Respuesta"
                    margin="normal"
                    type = {type}
                    autoComplete="off"
                    value={answer || ""}
                    onChange={(e) => handleChangeAnswer(e.target.value)}
                    required
                    inputProps = { {style: { 'textTransform': 'uppercase'}} }
                    error={!!formErrors.answer}
                    helperText={formErrors.answer}
                    InputLabelProps= { { style: { color: '#000000'} } }
                    InputProps = {{
                        endAdornment:
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleChangeTypeText}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {type === 'text' ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        
                    }}
                />
                    {/* 
                        <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={ (type === 'text') ? setType('password') : setType('text')}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {type === 'text' ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                        <Field
                        name="answer"
                        id="answer"
                        value = {answer}
                        onChange = {(e) => handleChangeAnswer(e.target.value)}
                        autoFocus = { true }
                        component={ RenderTextFieldRedux }
                        label="Respuesta"
                        fullWidth
                    /> */}
                </Grid>
                <Grid item xs={12} md={12} lg={12} xl={12} container justifyContent='flex-end'>
                    <Grid item xs={6} sm={6} md={2} lg={2} xl={2} container justifyContent='flex-end'>
                        {
                            (activeStep > 0) &&
                            <Button 
                                //style = {{ width : "140px"}}
                                variant="contained" 
                                className={classes.buttonBack}
                                onClick = { handleBack }
                            >
                                Atras
                            </Button>   
                        }
                    </Grid>
                    <Grid item xs={6} sm={6} md={2} lg={2} xl={2} container justifyContent='flex-end'>
                        <Button 
                            name={"accept"+index}
                            variant="contained"
                            //style = {{ width : "140px"}}
                            onClick = { handleNext }
                            className={classes.buttonBack}
                            disabled={ !isValid }
                        >
                            { (activeStep === (sizeSteps - 1)) ? "Guardar" : "Siguiente" }
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
    
    )
    
}

export default FormQuestions
